import React, { useEffect, useState } from 'react'
import Slider from 'react-slick/lib'
import moment from 'moment'
import ReactModal from 'react-modal'
import { PrevArrow, NextArrow } from '../elements/CarouselArrows'

import landIcon from '../../assets/icons/land-package-icon.svg'
import placeHolder from './placeholder.jpg'
import '../../styles/scss/components/equote-package-details-land-program.scss'
import closeIcon from '../../assets/icons/close.svg'

const renderNumberOfSlidesToShow = () => {
  if (window.innerWidth >= 1280) {
    return 2
  }

  return 1
}

function renderDisplayDate(startDate, day, format = 'dddd MMMM DD, YYYY') {
  return moment(startDate, 'YYYY-MM-DD')
    .add(Number(day) - 1, 'days')
    .format(format)
}

function renderSlides(landProgram, setDayDetailsForModal) {
  const { itinerary, startDate } = landProgram
  const fallBackImage = landProgram.packageImage
    ? landProgram.packageImage.src
    : null
  return itinerary.map((day, i) => {
    const displayDate = renderDisplayDate(startDate, day['field_day'])

    return (
      <div
        className="equote__package-details--land-program--slide"
        key={`land-program-day-slide-${i}`}
      >
        <div className="equote__package-details--land-program--slide--header">
          <p>{displayDate}</p>
          <div className="equote__package-details--land-program--slide--header-image-container">
            <img src={landIcon} alt="Land Program" />
          </div>
        </div>
        <div className="equote__package-details--land-program--slide--body">
          <div
            className="equote__package-details--land-program--slide--img-container"
            style={{
              backgroundImage:
                day['field_package_event_image'] &&
                day['field_package_event_image'].src
                  ? `url(${day['field_package_event_image'].src})`
                  : fallBackImage
                  ? `url(${fallBackImage})`
                  : `none`
            }}
          >
            <img src={placeHolder} alt="" style={{ display: 'none' }} />
          </div>
          <div className="equote__package-details--land-program--slide--details">
            <h4 className="equote__package-details--land-program--slide--day">
              Day {day['field_day']}
            </h4>
            <p className="equote__package-details--land-program--slide--description">
              {day['field_description'].length > 200 ? (
                <>
                  <span>{day['field_description'].slice(0, 200)}...</span>
                  <button
                    className="btn btn-hollow"
                    onClick={() =>
                      setDayDetailsForModal({ ...day, displayDate })
                    }
                  >
                    read more
                  </button>
                </>
              ) : (
                day['field_description']
              )}
            </p>
          </div>
        </div>
      </div>
    )
  })
}

const EQuotePackageDetailsLandProgram = props => {
  const { landProgram } = props
  const [numberOfSlidesToShow, setSlideCount] = useState(() =>
    renderNumberOfSlidesToShow()
  )
  const [dayDetailsForModal, setDayDetailsForModal] = useState(null)
  const handleResize = () => {
    setSlideCount(() => renderNumberOfSlidesToShow())
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return function cleanup() {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const settings = {
    lazyLoad: 'progressive',
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: numberOfSlidesToShow,
    swipeToSlide: true,
    prevArrow: (
      <PrevArrow {...props} numberOfSlidesToShow={numberOfSlidesToShow} />
    ),
    nextArrow: (
      <NextArrow {...props} numberOfSlidesToShow={numberOfSlidesToShow} />
    )
  }

  return (
    <>
      <div className="equote__package-details--land-program">
        <div className="equote__package-details--land-program--header">
          <p className="equote__package-details--land-program--header--sub-title">
            {landProgram.title}
            <span className="equote__package-details--land-program--header--pre-post-flag">
              <span>{`${props.type}-Cruise Land Program`}</span>
              <img src={landIcon} alt="Land Program" />
            </span>
          </p>
          <p className="equote__package-details--land-program--header--date">
            Beginning{' '}
            {moment(landProgram.startDate, 'YYYY-MM-DD').format(
              'MMMM Do, YYYY'
            )}
          </p>
        </div>

        <div className="equote__package-details--land-program--slider-container u-no-print">
          {landProgram.itinerary && landProgram.itinerary.length ? (
            <Slider {...settings}>
              {renderSlides(landProgram, setDayDetailsForModal)}
            </Slider>
          ) : null}
        </div>
        <div className="u-print-only">
          {landProgram.itinerary && landProgram.itinerary.length ? (
            <table className="u-table">
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Title</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {landProgram.itinerary.map(day => (
                  <tr key={day['field_day']}>
                    <td>
                      {renderDisplayDate(
                        landProgram.startDate,
                        day['field_day'],
                        'MMM DD, YYYY'
                      )}
                    </td>
                    <td>{day['field_title']}</td>
                    <td>{day['field_description']}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : null}
        </div>
      </div>
      {dayDetailsForModal && (
        <ReactModal
          isOpen={Boolean(dayDetailsForModal)}
          onRequestClose={() => setDayDetailsForModal(null)}
          style={{
            content: {
              top: '50%',
              transform: 'translate(-50%, -50%)'
            }
          }}
          className={{
            base: 'u-modal',
            afterOpen: 'u-modal--visible',
            beforeClose: 'u-modal--close',
            ariaHideApp: false
          }}
          overlayClassName={{
            base: 'u-fade',
            afterOpen: 'u-fade--visible',
            beforeClose: 'u-fade--visible'
          }}
          ariaHideApp={false}
        >
          <div style={{ paddingTop: '20px' }}>
            <div
              className="u-modal__close"
              onClick={() => setDayDetailsForModal(false)}
              tabIndex={0}
              style={{
                position: 'absolute',
                right: 0,
                top: '20px'
              }}
            >
              Close{' '}
              <img
                className="u-modal__close-icon"
                src={closeIcon}
                alt="eQuote Ship Modal Close"
              />
            </div>
            <h3>
              Day {dayDetailsForModal['field_day']} -
              {dayDetailsForModal.displayDate}
            </h3>

            <p>{dayDetailsForModal['field_description']}</p>
          </div>
        </ReactModal>
      )}
    </>
  )
}

export default EQuotePackageDetailsLandProgram
